import { render, staticRenderFns } from "./Ipv6.vue?vue&type=template&id=61dbb5a2&"
import script from "./Ipv6.vue?vue&type=script&lang=js&"
export * from "./Ipv6.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports